var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SubAPI } from "./SubAPI";
import { sleep } from "nate-react-api-helpers";
export class SupplierCategories extends SubAPI {
    listDefaults() { return this.fetcher.get("/api/project-supplier-category-defaults", {}); }
    upsertDefault(input) { return this.fetcher.post("/api/project-supplier-category-default", input); }
    reSortDefault(input) { return this.fetcher.post("/api/project-supplier-category-default/re-sort", input); }
    listForProject(input) { return this.fetcher.get("/api/project-supplier-categories", input); } // runs as a background task (the handler recalcs products after a by-others
    // change); post kicks it off, then we poll for the updated category.
    upsertForProject(input) {
        return __awaiter(this, void 0, void 0, function* () { const { task } = yield this.fetcher.post("/api/project-supplier-category", input); yield sleep(500); while (true) {
            const status = yield this.fetcher.get("/api/util/get-background-task", { task, withResult: true });
            if (status.done) {
                var _status$result;
                if ((_status$result = status.result) !== null && _status$result !== void 0 && _status$result.error)
                    throw new Error(status.result.error);
                return status.result;
            }
            yield sleep(1000);
        } });
    }
} // prefixedName renders a category with its parent, e.g.
// "Door Supplier / Wood Door Supplier", using the backend-provided parentName.
export function prefixedName(cat) { return cat.parentName ? `${cat.parentName} / ${cat.name}` : cat.name; } // buildSupplierTree nests a flat list by parent, ordered by sortOrder within
// each level. Orphans (missing parent) are treated as top-level.
export function buildSupplierTree(all) { const byId = new Map(); all.forEach(c => byId.set(c.id, Object.assign({}, c, { children: [], depth: 0 }))); const roots = []; byId.forEach(node => { const parent = node.parent !== null ? byId.get(node.parent) : undefined; if (parent) {
    parent.children.push(node);
}
else {
    roots.push(node);
} }); const sortRec = (nodes, depth) => { nodes.sort((a, b) => a.sortOrder - b.sortOrder); nodes.forEach(n => { n.depth = depth; sortRec(n.children, depth + 1); }); }; sortRec(roots, 0); return roots; } // flattenSupplierTree walks the tree depth-first so parents render immediately
// above their (indented) children while staying a single flat list.
export function flattenSupplierTree(nodes) { const out = []; const walk = list => { list.forEach(n => { out.push(n); walk(n.children); }); }; walk(nodes); return out; } // Aluminum and Existing door/frame suppliers are always supplied by others; their
// "By Us" override is force-unchecked and locked in the UI.
const forcedByOthersLabels = ["al-door-provider", "al-frame-provider", "ex-door-provider", "ex-frame-provider"];
export function forcesByOthers(cat) { return !!cat.internalLabel && forcedByOthersLabels.includes(cat.internalLabel); }
